import {Modal} from 'bootstrap';
import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'app-modal-select-salesperson',
  templateUrl: './modal-select-salesperson.component.html',
  styleUrls: ['./modal-select-salesperson.component.css'],
  standalone: false
})
export class ModalSelectSalespersonComponent implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;

  @Input() vm: any;
  deleteSalesperson;

  constructor() { }

  ngOnInit() {
  }

  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }

}
